import {
  connection,
  findRecord,
  insertRecord,
  transferMoney,
  updateRecord,
} from "./services.js";
import { toJalaali } from "jalaali-js";

async function getTourInfoForReserve(id, userId) {
  let information = {
    prices: {
      basePrice: 0,
      otherPrices: [],
      absolutePrice: { price: 0, state: true },
      reservation: false,
      reserveWithoutPrepayment: { state: false },
      reserveWithPrepayment: { state: false, price: 0 },
    },
    info: {
      title: "",
      type: "",
      startDate: "",
      startTime: "",
      startPlace: "",
      cover_pic: "",
      capacity: 0,
      main_status: 0,
    },
    pastPassangers: [],
    busType: 0,
    seats: [],
    wallet: false,
  };

  // mainInfo
  let data = await findRecord("tours", {
    conditions: `id/=/${id}`,
    fields:
      "title, stm, ftm, mainprice, cover_pic, main_status, (public_capacity - (frozen_reserved + complate_reserved)) as capacity",
  });
  let title = data[0].title,
    price = parseInt(data[0].mainprice);
  try {
    let stm = toJalaali(new Date(data[0].stm * 1000)),
      ftm = toJalaali(new Date(data[0].ftm * 1000));
    stm = `${stm.jy}/${(stm.jm < 10 ? "0" : "") + stm.jm}/${
      (stm.jd < 10 ? "0" : "") + stm.jd
    }`;
    ftm = `${ftm.jy}/${(ftm.jm < 10 ? "0" : "") + ftm.jm}/${
      (ftm.jd < 10 ? "0" : "") + ftm.jd
    }`;
    title += ` - ${ftm} تا ${stm}`;
  } catch (err) {
    console.log(err);
  }
  information = {
    info: {
      ...information.info,
      title,
      cover_pic: data[0].cover_pic,
      capacity: parseInt(data[0].capacity),
      main_status: parseInt(data[0].main_status),
    },
    prices: {
      ...information.prices,
      basePrice: price,
      absolutePrice: { price, state: true },
    },
  };

  // tour_other_field_values
  data = await findRecord("tour_other_field_values", {
    conditions: `tour_id/=/${id}@@code/in/2,3,8`,
    fields: "code, val",
  });
  if (data.length > 0) {
    let startPlace = data[data.findIndex((value) => value.code == 3)].val;
    let mtm = data[data.findIndex((value) => value.code == 2)].val,
      startTime = "",
      startDate = "";
    if (!isNaN(mtm)) {
      try {
        let date = new Date(mtm * 1000);
        startTime = `${(date.getHours() < 10 ? "0" : "") + date.getHours()}:${
          (date.getMinutes() < 10 ? "0" : "") + date.getMinutes()
        }`;
        mtm = toJalaali(date);
        startDate = `${mtm.jy}/${(mtm.jm < 10 ? "0" : "") + mtm.jm}/${
          (mtm.jd < 10 ? "0" : "") + mtm.jd
        }`;
      } catch (err) {
        console.log(err);
      }
    }
    information = {
      ...information,
      info: {
        ...information.info,
        startTime,
        startDate,
        startPlace,
      },
    };
    {
      let x = data[data.findIndex((value) => value.code == 8)]?.val;
      information.busType =
        typeof x == undefined || !x.includes("bus") ? 0 : x == "bus" ? 2 : 1;
    }
    if (information.busType == 1 || information.busType == 2) {
      // getSeats
      let seatsCount = information.busType == 1 ? 25 : 45;
      let x = Array(seatsCount).fill(1);
      let res = await findRecord("tour_reservation_items", {
        conditions: `tour_id/=/${id}`,
        fields: "seat_number",
      });
      res.forEach((value) => {
        if (value.seat_number != 0) {
          x[parseInt(value.seat_number) - 1] = 2;
        }
      });
      information.seats = x;
    }
  }
  data = await findRecord("tour_tags_links", {
    conditions: "tour_id/=/7",
    fields: "tour_tags.title",
    tbl_name: "tour_tags",
  });
  if (data.length > 0) {
    let tags = data.reduce((theTags, tag, index, arr) => {
      theTags += tag.title;
      if (index < arr.length - 1) {
        theTags += "، ";
      }
      return theTags;
    }, "");
    information.info = { ...information.info, type: tags };
  }

  // tour_additional_cost
  data = await findRecord("tour_additional_cost", {
    fields: "id,title,cost",
    conditions: `tour_id/=/${id}`,
  });
  if (data.length > 0) {
    let temp = data.map((value) => {
      return {
        id: value.id,
        title: value.title,
        price: parseInt(value.cost),
        state: false,
      };
    });
    information.prices = {
      ...information.prices,
      otherPrices: temp,
    };
  }
  data = await findRecord("user_tag_links", {
    conditions: `user_id/=/${userId}`,
    fields: "user_tag_id",
  });
  let userTags = data.reduce((total, value) => {
    return [...total, value.user_tag_id];
  }, []);
  data = await findRecord("tour_reservation_programs", {
    conditions: `tour_id/=/${id}@@user_tag_id/in/${userTags.join(",")}`,
    fields: "prepay",
  });
  if (data.length == 1) {
    information.prices = {
      ...information.prices,
      reservation: true,
      reserveWithPrepayment: {
        state: false,
        price: parseInt(data[0].prepay),
      },
    };
  } else if (data.length > 1) {
    let x = data.reduce((total, value) => {
      return total.prepay < value.prepay ? total : value;
    });
    information.prices = {
      ...information.prices,
      reservation: true,
      reserveWithPrepayment: {
        state: false,
        price: parseInt(x.prepay),
      },
    };
  } else {
    information.prices = {
      ...information.prices,
      reservation: false,
      reserveWithPrepayment: {
        state: false,
        price: 0,
      },
    };
  }

  // getPastPassangers
  data = await connection("pastpassengers", {
    user_id: userId,
  });
  information.pastPassangers = data.data;

  let res = await findRecord("wallets", {
    conditions: `uid/=/${userId}`,
    fields: "current_inventory",
  });
  information.wallet =
    res.length > 0 ? parseInt(res[0].current_inventory) : false;
  console.log(information);
  return information;
}

async function reserveTour(
  userId,
  tourId,
  seats,
  busType,
  totalPrice,
  payPrice,
  payType,
  passangers,
  ACIds
) {
  let passangerCount = passangers.length + 1;
  let payState = payType == "online" ? 0 : payPrice != 0 ? 1 : 2;
  let res;
  let tour = await findRecord("tours", {
    conditions: `id/=/${tourId}`,
    fields: "complate_reserved, frozen_reserved",
  });
  if (tour.length == 0) return false;
  tour = {
    complate_reserved: parseInt(tour[0].complate_reserved),
    frozen_reserved: parseInt(tour[0].frozen_reserved),
  };

  let factor = {
    uid: userId,
    muid: userId,
    total_count: passangerCount,
    total_amt: totalPrice,
    total_paid: payPrice,
    main_status: payState == 2 ? 2 : 0,
  };
  let flag = false;
  let factorId = await insertRecord("factors", factor);
  if (!Boolean(factorId.status)) return false;
  factorId = factorId.result.id;
  passangers = await Promise.all(
    passangers.map(async (value) => {
      if (value.id == -1) {
        let birthdate = ["", "", ""];
        if (value.birthdate != "") {
          birthdate = value.birthdate.split("/");
        }
        res = await insertRecord("users", {
          fname: value.firstname,
          lname: value.lastname,
          codemelli: value.code,
          mobile: value.phone,
          bdyear: birthdate[0],
          bdmonth: birthdate[1],
          bdday: birthdate[2],
          email: value.email,
        });
        if (res.status) {
          value.id = res.result.id;
        } else {
          flag = true;
        }
      }
      return value;
    })
  );
  if (flag) return false;
  
  let keyvalues;
  if (payState == 0) {
    keyvalues = { frozen_reserved: tour.frozen_reserved + 1 };
  } else {
    let userWallet = await findRecord("wallets", {
      conditions: `uid/=/${userId}`,
      fields: "id, current_inventory",
    });
    let master = await findRecord("wallets", {
      conditions: `type/=/1`,
      fields: "id",
    });
    if (userWallet.length == 0 || master.length == 0) return false;
    userWallet = userWallet[0];
    master = master[0];
    if (payState == 2) {
      if (totalPrice > userWallet.current_inventory) return false;
      res = await transferMoney(userWallet.id, master.id, 1, totalPrice, factorId);
      if (res === false) return;
      keyvalues = { complate_reserved: tour.complate_reserved + 1 };
    } else {
      res = await transferMoney(
        userWallet.id,
        master.id,
        1,
        totalPrice - payPrice,
        factorId
      );
      if (res === false) return;
      keyvalues = { frozen_reserved: tour.frozen_reserved + 1 };
    }
  }
  res = await updateRecord("tours", {
    conditions: `id/=/${tourId}`,
    keyvalues,
  });

  let seatnumbers = [];
  if ("1,2".includes(busType)) {
    let i = -1;
    do {
      i = seats.indexOf(3, i + 1);
      console.log(i);
      if (i != -1) {
        seatnumbers.push(i + 1);
      }
    } while (i != -1);
  }
  let reservation_item = Array(passangerCount)
    .fill()
    .map((value, index) => {
      value = {
        muid: userId,
        uid: index != 0 ? passangers[index - 1].id : userId,
        factor_id: factorId,
        tour_id: tourId,
        seat_number: 0,
        total_paid_state: payState,
        main_state: payState == 2 ? 2 : 0,
        other_params: JSON.stringify({
          additional_costs: ACIds.map((value) => {
            return {
              id: value,
              discount: 0,
            };
          }),
        }),
      };
      if ("1,2".includes(busType)) {
        value.seat_number = seatnumbers[index];
      }
      return value;
    });

  flag = false;
  await Promise.all(
    reservation_item.map(async (value) => {
      let res = await insertRecord("tour_reservation_items", value);
      if (!Boolean(res.status)) {
        flag = true;
      }
      return res;
    })
  );
  if (flag) return false;

  if (payState == 2) return { state: 2, url: "/customer-panel/orders" };

  let price = totalPrice;
  if (payState == 1) price -= payPrice;

  res = await connection("payfactor", {
    factor_id: factorId,
    amounttopay: price,
    callback: "customer-panel/orders",
  });
  return { state: res.state == 1 ? 1 : 0, url: res.data.url };
}

export { getTourInfoForReserve, reserveTour };
